module.exports = __webpack_public_path__ + "officialStatic/img/TCLlogo.9b63443.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wireless/TCLlogo.png
// module id = 5J2x
// module chunks = 0